/* jshint esversion: 6 */

import {LoggingService} from "logging/LoggingService";

export function ErrorStack( errorPrefix = "Error occurred" ) {
    let errors = [];

    // revealing public api
    return {

        add: ( errorCode, msg ) => {
            const message =  msg || "";
            errors.push( [errorCode,message] );
            LoggingService.log( `${errorPrefix}: ${errorCode} - ${message}` );
        },

        clear: function () {
            errors = [];
        },

        getLast: function () {
            const error = (errors.length > 0) ? errors[errors.length-1] : [0,""];
            return {
                code: error[0],
                message: error[1]
            }
        },

        isEmpty: () => errors.length === 0,

        log: () => {
            LoggingService.log( `${errorPrefix}:` );
            errors.forEach( ( error ) => {
                const msg = error[1] ? `, Message:${error[1]}` : "";
                LoggingService.log( `Code: ${error[0]}${msg}` );
            });
        }
    };
}
